import { Address, EnrichedAddress } from '@rygen/rygen-ui/model';

import { RouteResponse } from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'geocoding';

export class GeoCodingController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async getGeoCodedLocation(address: Address): Promise<EnrichedAddress> {
    const response = await this.http.post<EnrichedAddress>('location', address);
    return new EnrichedAddress(response.data);
  }

  async getRoute(stopString: string): Promise<RouteResponse[]> {
    const response = await this.http.get<RouteResponse[]>(`route`, {
      params: { stopString },
    });
    return response.data.map((r) => new RouteResponse(r));
  }
}
